import {
  appStateMock,
  audio,
  audioFormValidation,
  song,
} from 'app/utils/test/constants';
import { AudioStatusReasonType, AudioStatusType } from 'types/audio';

export const SUPPORTED_AUDIO_FILES = {
  'audio/*': ['.bwav', '.alac', '.CAF', '.ogg'],
  'audio/midi': ['.mid', '.midi'],
};

export const TEST_STATES = {
  apiResponse: {
    response: {
      schema: {
        properties: {
          body: {
            properties: audioFormValidation,
          },
        },
      },
    },
  },
  audioListWithStatusesApiResponse: {
    response: {
      audio: {
        items: [
          { ...audio, statusReason: AudioStatusReasonType.UPLOADING },
          {
            ...audio,
            guid: 'other-guid',
            statusReason: AudioStatusReasonType.TRANSCODING,
          },
        ],
      },
    },
  },
  audioWithRemarkApiResponse: {
    response: {
      audio: {
        items: [{ ...audio, remark: 'remark' }],
      },
    },
  },
  emptyAudioListResponse: {
    response: {
      audio: {
        items: [],
      },
    },
  },
  audioListWithPrivateAudioResponse: {
    response: {
      audio: {
        items: [{ ...audio, isPrivate: true, status: AudioStatusType.SUCCESS }],
      },
    },
  },
  emptyPageState: {
    ...appStateMock,
    songList: {
      ...appStateMock.songList,
      song: {
        ...song,
        audio: [],
      },
      songAudioValidations: audioFormValidation,
      songAudioTypes: {
        Bounce: {
          key: 'Bounce',
          name: 'Bounce',
        },
      },
    },
  },
  loadingPageState: {
    ...appStateMock,
    songList: {
      ...appStateMock.songList,
      song,
      songAudioValidations: audioFormValidation,
      songAudioTypes: {
        Bounce: {
          key: 'Bounce',
          name: 'Bounce',
        },
      },
    },
  },
  pageWithoutAudioListState: {
    ...appStateMock,
    songList: {
      ...appStateMock.songList,
      song,
      songAudioValidations: audioFormValidation,
      songAudioTypes: {
        Bounce: {
          key: 'Bounce',
          name: 'Bounce',
        },
      },
    },
  },
  pageWithRetryableAudio: {
    ...appStateMock,
    songList: {
      ...appStateMock.songList,
      song: {
        ...song,
        audio: [],
      },
      localAudio: {
        [song.guid]: [
          {
            ...audio,
            guid: 'audio-guid-2',
            status: AudioStatusType.FAILURE,
            statusReason: AudioStatusReasonType.RETRYABLE,
          },
        ],
      },
      songAudioValidations: audioFormValidation,
      songAudioTypes: {
        Bounce: {
          key: 'Bounce',
          name: 'Bounce',
        },
      },
    },
  },
};
